
import React, { useEffect } from 'react';
import { initDiagnosticServices, isDiagnosticsEnabled } from './utils/diagnosticsUtils';

/**
 * Component to initialize diagnostic services when the application starts
 */
const DiagnosticsInitializer: React.FC = () => {
  useEffect(() => {
    // Initialize diagnostic services when component mounts
    initDiagnosticServices();
    
    // Log that diagnostics are initialized
    const isDiagnosticsOn = isDiagnosticsEnabled();
    console.log(`Diagnostics services initialized. Diagnostics enabled: ${isDiagnosticsOn}`);
  }, []);

  // This component doesn't render anything
  return null;
};

export default DiagnosticsInitializer;
